import styled from 'styled-components'
import { slideIn, appear, shrink } from 'components/corpSite/components/theme/animations'; 
import { white, primaryForSite } from 'components/corpSite/components/theme/colors'
import { spacing_1 } from 'components/corpSite/components/theme/spacing'
import { h4_bold } from 'components/corpSite/components/theme/type-styles';

export function makeMobileNavItem (element) {
  return styled(element)`
    ${appear};
    ${slideIn};
    ${shrink};

    opacity: 0;
    animation: appear 1s forwards;
    animation-delay: ${props => props.delay};

    a {
      animation: slideIn 0.5s forwards;
      animation-delay: ${props => props.delay};

      ${ h4_bold };
      display: inline-block;
      width: 100%;
      color: ${ white };
      padding: ${ spacing_1 } 0;
      margin: 0 auto;
      font-weight: normal;
      background-color: #024f4b;

      &:hover {
        transition: background 0.1s;
        text-decoration: none;
        color: ${ white };
        background-color: #04857e;
      }

      &.mobileNavHeader {
        font-weight: bold;
      }
    }

    .line {
      width: 90%;
      height: 1px;
      background: #04857e;
      margin: 0 auto;
      animation: shrink 0.5s forwards;
      animation-delay: ${props => props.delay}; 
    }
  `
}

export default makeMobileNavItem